import { styled } from '@mui/material';

import { focusProps, Icons } from '@cast/design-system';

import { useMainLayout } from '../../../../_providers/MainLayoutProvider';

const Container = styled('button')(({ theme }) => ({
  all: 'unset',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '20px',
  height: '20px',
  borderRadius: '4px',
  background: 'transparent',
  '& svg': {
    color: theme.palette.grey[700],
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.grey[900],
    },
  },
  '&:focus-visible': {
    opacity: 1,
    ...focusProps(),
  },
}));

export const SidebarCollapseButton = () => {
  const {
    secondarySidebarState,
    collapseSecondarySidebar,
    pinSecondarySidebar,
  } = useMainLayout();
  const sidebarCollapsed = secondarySidebarState !== 'pinned';

  const handleSidebarSize = () => {
    if (sidebarCollapsed) {
      pinSecondarySidebar();
    } else {
      collapseSecondarySidebar();
    }
  };

  const a11yLabel = `${sidebarCollapsed ? 'Pin' : 'Collapse'} Sidebar`;

  return (
    <Container
      onClick={handleSidebarSize}
      aria-label={a11yLabel}
      data-testid="collapse-btn"
    >
      <Icons.WithRotation rotated={!sidebarCollapsed}>
        <Icons.CaretDoubleRight size="16px" />
      </Icons.WithRotation>
    </Container>
  );
};
